/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Grid, CircularProgress } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import Kpi from "../../components/KPI/Kpi";
import { useSelections } from "../../context/Selections";

function ExtraScoresMobile({ app, config }) {
  const [singleGroupView, setSingleGroupView] = useState(false);
  const { selections } = useSelections();

  const [value, goalValue, remainingvalue, percentage] = [
    Kpi({
      app,
      objectId: "2df4c413-b7fd-4323-942d-f524a8445463",
      updatesWithSelection: true,
    }),
    Kpi({
      app,
      objectId: "7ba9ddab-7438-480e-81d1-04cefea410f8",
      updatesWithSelection: true,
    }),
    Kpi({
      app,
      objectId: "PpHqKU",
      updatesWithSelection: true,
    }),
    Kpi({
      app,
      objectId: "882b9577-1ed6-4dd5-b434-18daae26eb38",
      updatesWithSelection: true,
    }),
  ];

  const [percentageNum, setPercentageNum] = useState(percentage);

  useEffect(() => {
    if (app) {
      const num = percentage ? percentage.slice(0, -1) * 1 : 0;
      setPercentageNum(num > 100 ? 100 : num);
    }
  }, [app, percentage]);

  useEffect(() => {
    if (app) {
      // Update title with selected distribution group (when only 1 is selected)
      const groups = selections.length
        ? selections.find((s) => s.qField === "Grupo Distribuição")
        : null;
      setSingleGroupView(groups?.qSelectedCount === 1);
    }
  }, [app, selections]);

  const atingimentoDetail = (
    <NativeObject
      app={app}
      key="wTNc"
      type={"table"}
      reference={{
        id: "wTNc",
      }}
      style={{
        padding: "0 12px ",
      }}
    />
  );

  return (
    <div className="app ExtraScores">
      <div className="appContent">
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"space-between"}
          alignItems={"start"}
          rowGap={2}
        >
          {/* TITLE */}
          <Grid item sx={{}}>
            <Box component={"h1"}>Sell out Total</Box>
          </Grid>

          <Grid container flexDirection={"column"} justifyContent={"flex-start"} rowGap={2}>
            <Grid container item flexDirection={"column"} justifyContent={"flex-start"} rowGap={2}>
              <Grid container item justifyContent={"flex-start"} rowGap={2}>
                <Grid item xs={12}>
                  <Card
                    app={app}
                    detailButton
                    detailContent={atingimentoDetail}
                    exportTableId={"wTNc"}
                    header={{
                      hardTitle: "Atingimento",
                    }}
                  >
                    <Grid
                      className="sell-out-wrapper"
                      container
                      flexDirection={"column"}
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                    >
                      <Grid item container justifyContent={"space-between"} alignItems={"center"} xs={12}>
                        <Grid item xs>
                          <CircularProgress
                            determinate
                            thickness={36}
                            variant="soft"
                            value={percentageNum}
                            sx={{
                              margin: "0 0 24px 24px",
                              "--CircularProgress-size": "188px",
                              "--CircularProgress-linecap": "butt",
                              "--CircularProgress-trackColor": "#BEE3F1",
                              "--CircularProgress-progressColor": "#55B6EB",
                            }}
                          >
                            <Box
                              component={"span"}
                              sx={{
                                color: percentageNum > 0 ? "#55B6EB" : "#BEE3F1",
                              }}
                            >
                              {percentage ?? "0%"}
                            </Box>
                          </CircularProgress>
                        </Grid>
                        <Grid item container flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"} xs>
                          <Grid item xs>
                            <Box className="label" component={"span"}>
                              Meta:&nbsp;&nbsp;
                            </Box>
                            <Box className="value" component={"span"}>
                              {goalValue}
                            </Box>
                          </Grid>
                          <Grid item xs>
                            <Box className="label" component={"span"}>
                              Realizado:&nbsp;&nbsp;
                            </Box>
                            <Box className="value" component={"span"}>
                              {value}
                            </Box>
                          </Grid>
                          {remainingvalue && remainingvalue[0] !== "-" && (
                            <Grid item xs>
                              <Box className="label" component={"span"}>
                                Faltante:&nbsp;&nbsp;
                              </Box>
                              <Box className="value" component={"span"}>
                                {remainingvalue}
                              </Box>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card app={app}>
                    <ComboHeader
                      reference={{
                        title: {
                          hard: "Performance Distribuidor",
                        },
                      }}
                    />
                    <NativeObject
                      app={app}
                      key="FdbCXf"
                      type={"table"}
                      reference={{
                        id: "FdbCXf",
                      }}
                      style={{
                        padding: "0 12px ",
                      }}
                    />
                  </Card>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Card app={app}>
                  <ComboHeader
                    reference={{
                      title: {
                        hard: "Scorecard Atingimento",
                      },
                    }}
                    legends={
                      singleGroupView
                        ? [
                            {
                              type: "bar",
                              iconColor: "#254d74",
                              name: "Ano Anterior",
                            },
                            {
                              type: "bar",
                              iconColor: "#55B6EB",
                              name: "Ano Atual",
                            },
                          ]
                        : [
                            {
                              type: "bar",
                              iconColor: "#F98561",
                              name: "Meta",
                            },
                            {
                              type: "bar",
                              iconColor: "#55B6EB",
                              name: "Realizado",
                            },
                            {
                              type: "bar",
                              iconColor: "#FDB949",
                              name: "Pontos",
                            },
                          ]
                    }
                  />
                  <NativeObject
                    app={app}
                    key="PTcYm"
                    type={"barchart"}
                    reference={{ id: "PTcYm" }}
                    style={{
                      padding: "0 12px ",
                    }}
                  />
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

ExtraScoresMobile.defaultProps = {
  app: null,
  config: {},
};

ExtraScoresMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default ExtraScoresMobile;
